/**
 * Color hex values for display parameter color modes.
 * Maps color mode names to hex color strings for use in Three.js and UI.
 */
export const DisplayParamColors = Object.freeze({
    BLACK: '#000000',
    WHITE: '#ffffff',
    DARK_BLUE: '#0e007a',
    RED: '#ff0000',
    GREY: '#808080',
    // Add more as needed
});
/**
 * constants.js
 *
 * Centralized enums and constants for the Text Embeddings Visualization app.
 * Includes color mode enums for display parameters, environment, and fog, as well as app metadata.
 *
 * Copyright (c) 2023-2025, text-embedding-visualization authors.
 * Licensed under the MIT License.
 */
/**
 * Enum for environment color modes.
 * Used for setting the background/environment color in the visualization.
 * @readonly
 * @enum {string}
 */
export const DisplayParamEnvironmentColorMode = Object.freeze({
    BLACK: 'black',
    WHITE: 'white',
    DARK_BLUE: 'dark_blue',
});

/**
 * Enum for fog color modes.
 * Used for setting the fog color in the visualization.
 * @readonly
 * @enum {string}
 */
export const DisplayParamFogColorMode = Object.freeze({
    NONE: 'none',
    BLACK: 'black',
    WHITE: 'white',
    DARK_BLUE: 'dark_blue',
});
/**
 * Enum for display parameter token color modes.
 * Used for coloring points/lines in the embedding visualization.
 * @readonly
 * @enum {string}
 */
export const DisplayParamTokenColorMode = Object.freeze({
    SEQUENCE: 'sequence',
    TOKEN_ID: 'id',
    NONE: 'none',
    BLACK: 'black',
    WHITE: 'white',
    // Add more modes as needed
});

/**
 * Enum for display parameter label color modes.
 * Used for coloring labels in the embedding visualization.
 * @readonly
 * @enum {string}
 */
export const DisplayParamLabelColorMode = Object.freeze({
    SEQUENCE: 'sequence',
    TOKEN_ID: 'id',
    NONE: 'none',
    BLACK: 'black',
    WHITE: 'white',
    DARK_BLUE: 'dark_blue',
    // Add more modes as needed
});
// src/constants.js
export const TEV_SCHEMA_VERSION = "3.0.0";
export const TEV_APP_VERSION = "1.0.0";
export const TEV_APP_NAME = "Text Embeddings Visualization";
export const TEV_FILE_TYPE = "tev_pca_file";
